import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEEmailCardActions = {
  initPeEmailCard: ({ commit }, index) => {
    commit('setPeEmailCardLock', { index, lock: true })
  },
  peEmailMultipleCardCreate: ({ dispatch }, sections) => {
    return sections.reduce((acc, section) => {
      if (acc) return acc.then(_ => dispatch('peEmailCardCreate', { section, index: 'new' }))
      else return dispatch('peEmailCardCreate', { section, index: 'new' })
    }, null)
  },
  peEmailCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        emails: {
          party_id: party.id,
          address: section.address,
          no_email: section.no_email,
          owner: section.owner,
          primary: section.primary,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeEmailCardLock', { index, lock: true })
        commit('pePatchParty', {
          emails: updatedParty.emails || [],
        })
      }).
      catch(handleError)
  },
  peEmailCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/emails/${section.id}`).
      then(({ data }) => {
        commit('setPeEmailCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'emails',
          value: data,
        })
      }).
      catch(handleError)
  },
  peEmailCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        emails: {
          party_id: party.id,
          address: section.address,
          no_email: section.no_email,
          owner: section.owner,
          primary: section.primary,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeEmailCardLock', { index, lock: true })
        commit('pePatchParty', {
          emails: updatedParty.emails || [],
        })
      }).
      catch(handleError)
  },
  peEmailCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          emails: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeEmailCardLock', { index, lock: true })
        commit('pePatchParty', {
          emails: updatedParty.emails || [],
        })
      }).
      catch(handleError)
  },
  peEmailCardAddSection: ({ commit }) => {
    commit('setPeEmailCardLock', { index: 'new', lock: false })
    commit('addPeEmailCardSection', {
      id: null,
      address: '',
      no_email: '',
      owner: '',
      primary: '',
    })
  },
}

export const PEEmailCardMutations = {
  setPeEmailCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.EmailCard) Vue.set(state.partyEdit.partySections, 'EmailCard', {})
    Vue.set(state.partyEdit.partySections.EmailCard, index, lock)
  },
  addPeEmailCardSection: (state, section) => {
    state.partyEdit.party.emails.push(section)
  },
  peEmailCardCreateUndo: state => state.partyEdit.party.emails.pop(),
}

export const PEEmailCardGetters = {
  peEmailCardLock: state => index => state.partyEdit.partySections.EmailCard[index],
  peEmailCardHasNewSection: (_, getters) => !!getters.peParty.emails?.find(email => email.id === null),
}
